import React, { useState } from "react";
import COLOR from '../../global/Color'
import SIZE from '../../global/Size'
import MainLogo from '../button/navigationBtn/MainLogo'
import ComponyBtn from '../button/navigationBtn/CompanyBtn'
import RecruitBtn from '../button/navigationBtn/RecruitBtn'
import TechnologiesBtn from '../button/navigationBtn/TechnologiesBtn'
import VenderProductBtn from '../button/navigationBtn/VenderProductBtn'
import ContactBtn from '../button/navigationBtn/ContactBtn'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import LogoImage from '../../assets/eplusLogo.png'
import { useLanguage } from "../../context/LanguageContext";
import { navigationCopy } from "../../i18n/landingCopy";

const MainNaviagation = ({children}) => {
  const { language, setLanguage } = useLanguage();
  const navCopy = navigationCopy[language] || navigationCopy.en;

  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

    return (
      <HeaderContainer>
        <MainLogo>
          <StyledLink to="/">
            <StyledlogoImage src={LogoImage}/>
          </StyledLink>
        </MainLogo>
        <ComponyBtn>
          <StyledLink className='animated-button' to="/company">{navCopy.company}</StyledLink>
        </ComponyBtn>
        <VenderProductBtn>
          <StyledLink className='animated-button' to="/vendor">{navCopy.vendorProduct}</StyledLink>
        </VenderProductBtn>
        <TechnologiesBtn>
          <StyledLink className='animated-button' to="/technologies">{navCopy.technologies}</StyledLink>
        </TechnologiesBtn>
        <RecruitBtn>
          <StyledLink className='animated-button' to="/recruit">{navCopy.recruit}</StyledLink>
        </RecruitBtn>
        <ContactBtn>
          <StyledLink to="/contact">{navCopy.contact}</StyledLink>
        </ContactBtn>
        <LanguageToggle aria-label="language switch">
          <LanguageButton
            type="button"
            $isActive={language === "en"}
            onClick={() => setLanguage("en")}
          >
            <span role="img" aria-label="USA flag">🇺🇸</span> EN
          </LanguageButton>
          <LanguageButton
            type="button"
            $isActive={language === "ko"}
            onClick={() => setLanguage("ko")}
          >
            <span role="img" aria-label="Korea flag">🇰🇷</span> KO
          </LanguageButton>
        </LanguageToggle>
        <HamburgerBtn onClick={toggleNav}>
          ☰
        </HamburgerBtn>
        <NavContainer $isOpen={isOpen}>
          <NavList>
            <NavItem to="/company">{navCopy.company}</NavItem>
            <NavItem to="/vendor">{navCopy.vendorProduct}</NavItem>
            <NavItem to="/technologies">{navCopy.technologies}</NavItem>
            <NavItem to="/recruit">{navCopy.recruit}</NavItem>
            <NavItem to="/contact">{navCopy.contact}</NavItem>
          </NavList>
        </NavContainer>
      </HeaderContainer>
    );
  }

  const HamburgerBtn = styled.div`
    position: absolute;
    right: 20px;
    font-size: xx-large;
    cursor: pointer;
    display: none;
    z-index: 999;
    color: mediumpurple;
    line-height: 1;

    /* 0px 이상 1000px 미만 */
    @media (min-width: 0px) and (max-width: 1000px) {
      display: inline-block;
    }
  `
  const LanguageToggle = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: 8px;
    position: absolute;
    right: 60px;
    z-index: 998;

    @media (min-width: 0px) and (max-width: 1000px) {
      right: 78px;
      gap: 4px;
    }

    @media (max-width: 449px) {
      right: 72px;
    }
  `;

  const LanguageButton = styled.button`
    border: 1px solid rgba(255, 255, 255, 0.4);
    background: ${({ $isActive }) => ($isActive ? "rgba(255, 255, 255, 0.2)" : "transparent")};
    color: ${props => props.theme.COLOR.WHITE};
    width: 62px;
    height: 34px;
    border-radius: 999px;
    padding: 0;
    font-size: 13px;
    cursor: pointer;
    font-weight: 700;
    letter-spacing: 0.06em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    line-height: 1;

    &:hover {
      background: rgba(255, 255, 255, 0.18);
    }

    @media (min-width: 450px) and (max-width: 1000px) {
      width: 54px;
      height: 31px;
      font-size: 11px;
      gap: 4px;
      letter-spacing: 0.04em;
    }

    @media (max-width: 449px) {
      width: 50px;
      height: 30px;
      font-size: 11px;
      gap: 4px;
      letter-spacing: 0.03em;
    }
  `;

    const HeaderContainer = styled.div`
    width: 100%;
    height: 6vh;
    background-color: ${props => props.theme.COLOR.BLACKPEARL};
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.COLOR.WHITE};
    font-size: ${props => props.theme.SIZE.LARGE};
    z-index: 999;

    /* 450px 이상 1000px 미만 */
    @media (min-width: 450px) and (max-width: 1000px) {
      justify-content: flex-start;
      align-items: center;
    }
    
    /* 450px 미만 */
    @media (max-width: 449px) {
      justify-content: flex-start;
      align-items: center;
    }
  `;

    const NavContainer = styled.div`
      position: fixed;
      top: 0;
      right: 0;
      width: 300px;
      height: 100%;
      background-color: #333;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: ${({ $isOpen }) => ($isOpen ? 'translateX(0)' : 'translateX(100%)')};
      transition: transform 0.3s ease-in-out;
      z-index: 99;
    `;

    const NavList = styled.div`
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    `;

    const NavItem = styled(Link)`
      color: #fff;
      text-decoration: none;
      font-size: 1.5rem;

    &:hover {
      color: #ddd;
    }
    `;
  
  const StyledLink = styled(Link)`
    color: ${props => props.theme.COLOR.WHITE};
    text-decoration: none;
    height: 100%;
    width: 100%;
    text-align: center;
    font-weight: 600;
    place-content: center;

    /* 1300px 이상 1500px 미만 */
    @media (min-width: 1300px) and (max-width: 1499px) {
      width: 80%;
    }

    /* 800px 이상 1300px 미만 */
    @media (min-width: 800px) and (max-width: 1299px) {
      width: 70%;
    }
  `;

  const StyledlogoImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: scale(0.4);

    /* 450px 이상 800px 미만 */
    @media (min-width: 800px) and (max-width: 1300px) {
      transform: scale(0.7);
    }

    /* 450px 이상 800px 미만 */
    @media (min-width: 450px) and (max-width: 799px) {
      transform: scale(0.6);
    }

    /* 450px 미만 */
    @media (max-width: 449px) {
      transform: scale(0.6);
    }
  `;

export default MainNaviagation
